import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const DumbbellDiagonalIcon = (props: IconProps) => (
  <StyledIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M11.1631 2.12402C10.331 2.95604 10.331 4.30501 11.1631 5.13703L18.863 12.8369C19.695 13.669 21.044 13.669 21.876 12.8369C22.708 12.0049 22.708 10.656 21.876 9.82394L14.1761 2.12402C13.344 1.292 11.9951 1.29199 11.1631 2.12402Z"
      fill="currentColor"
    />
    <path
      d="M2.35836 18.4278C1.7667 17.8361 1.7667 16.8768 2.35836 16.2852C2.50628 16.1373 2.74609 16.1373 2.89401 16.2852L7.71483 21.106C7.86274 21.2539 7.86274 21.4937 7.71483 21.6416C7.12317 22.2333 6.1639 22.2333 5.57224 21.6416L2.35836 18.4278Z"
      fill="currentColor"
    />
    <path
      d="M16.2852 2.89401C16.1373 2.74609 16.1373 2.50628 16.2852 2.35836C16.8768 1.7667 17.8361 1.7667 18.4278 2.35836L21.6416 5.57224C22.2333 6.1639 22.2333 7.12317 21.6416 7.71483C21.4937 7.86274 21.2539 7.86274 21.106 7.71483L16.2852 2.89401Z"
      fill="currentColor"
    />
    <path
      d="M2.12402 14.1761C1.29199 13.344 1.29199 11.9951 2.12402 11.1631C2.95604 10.331 4.30501 10.331 5.13703 11.1631L12.8369 18.863C13.669 19.695 13.669 21.044 12.8369 21.876C12.0049 22.708 10.656 22.708 9.82393 21.876L2.12402 14.1761Z"
      fill="currentColor"
    />
    <path
      d="M8.98699 13.0043C8.80209 13.1892 8.80209 13.489 8.98699 13.6739L10.3261 15.013C10.511 15.1979 10.8108 15.1979 10.9957 15.013L15.013 10.9957C15.1979 10.8108 15.1979 10.511 15.013 10.3261L13.6739 8.98699C13.489 8.80209 13.1892 8.80209 13.0043 8.98699L8.98699 13.0043Z"
      fill="currentColor"
    />
  </StyledIcon>
)
